import { useEffect, useState } from "react";

// userContext
import { UserContext } from "./UserContext";

// url imports
import { urls } from "../api-urls/api-urls";

// react router dom import
import { useLocation, useNavigate } from "react-router-dom";







export const UserProvider = ({ children }) => {

  // localStorage.setItem("token", "kasgkk");

  // GET the useLocation
  const location = useLocation();

  // GET the useNavigate
  const navigate = useNavigate();

  // state definition
  const [user, setUser] = useState({});


  const setUserContext = (user) => {
    setUser(user);
  };



  // funcion para consultar la informacion del usuario en dado caso que se pierda
  const fetchDataUser = async () => {

    const END_POINT = `${urls.authRoute}/get-user-info`;

    const TOKEN = localStorage.getItem("token");

    // console.log(TOKEN)

    try {
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Authorization": TOKEN,
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();

      if (response.status === 200) {
        setUser(data?.UserInfo);
      } else if (response.status === 401) {
        localStorage.setItem("last_locat", JSON.stringify(location));
        localStorage.removeItem("token");
        return navigate("/");
      }

    } catch (error) {
      console.log(error);
    }
  };



  // useEffect para solicitar data al servidor
  useEffect(() => {
    if (user && Object.keys(user).length === 0 && localStorage.getItem("token")) {
      // consultar la informacion al servidor
      fetchDataUser();
    }
  }, [user]);

  // console.log("Este es el valor del usuario", user)

  // if (login && location.search) {
  //   return (
  //     <LoginFloat setUserC={setUserContext} />
  //   )
  // }


  return (
    <UserContext.Provider value={{ user, setUserContext }}>
      {children}
    </UserContext.Provider>
  )
};